import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { FeatureGroup } from 'react-leaflet';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { MAP_LEGEND, MAP_TYPE } from '../../../../../lib/constants';
import { selectTeamCells } from '../../../../../redux';
import HeatMapLayer from './HeatMapLayer';
/**
 * @param {'pinScore' | 'qualifiedAddresses'} mapType
 */
const HeatMap = ({ mapType }) => {
    const { teamCells } = useSelector(selectTeamCells);
    const cells = useMemo(() => {
        if (!teamCells?.features) {
            return {};
        }
        let cells = {};
        switch (mapType) {
            case MAP_TYPE.PIN_SCORE:
                teamCells.features.forEach((cell) => {
                    const quartile = cell.properties.avg_qualified_area_quartile ?? 0;
                    const quartileStyles = MAP_LEGEND.QUALIFIED_AREAS_CHOROPLETH_SCALE
                        .find((style) => style.quartile === quartile);
                    const cellProperties = {
                        ...cell,
                        style: quartileStyles,
                    };
                    if (cells[quartile]) {
                        cells[quartile].push(cellProperties);
                    }
                    else {
                        cells[quartile] = new Array(cellProperties);
                    }
                });
                return cells;
            case MAP_TYPE.QUALIFIED_ADDRESSES:
                cells = {
                    1: [],
                    2: [],
                    3: [],
                    4: [],
                    5: [],
                    6: [],
                    7: [],
                    8: [],
                    9: [],
                    10: [],
                };
                teamCells.features.forEach((cell) => {
                    const decile = cell.properties.decile_on_qualified_addresses;
                    cells[decile].push({
                        ...cell,
                        style: MAP_LEGEND.QUALIFIED_ADDRESS_CHOROPLETH_SCALE[decile - 1],
                    });
                });
                return cells;
            default:
                return cells;
        }
    }, [teamCells]);
    return (_jsx(FeatureGroup, { children: Object.keys(cells).map((key) => (_jsx(HeatMapLayer, { cells: cells[key] }, uuidv4()))) }));
};
HeatMap.propTypes = {
    mapType: PropTypes.string,
};
export default HeatMap;
